module.exports = __webpack_public_path__ + "img/feiyi.125ef1b4.jpg";